import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { AdminMapeosClaveCuentaPage } from "@/features/admin-mapeos-clave-cuenta/components/AdminMapeosClaveCuentaPage";
import { mapeosClaveCuentaQueryOptions } from "@/features/admin-mapeos-clave-cuenta/hooks/use-mapeos-clave-cuenta";

/**
 * Ruta `/admin/mapeos-clave-cuenta` · gestor del catálogo "clave
 * producto/servicio SAT → cuenta contable" (equivalente de dbo.Tag).
 * Paginado server-side (P42) · precarga la primera página + las cuentas
 * contables (Select del alta/edición).
 */
export const Route = createFileRoute("/_authed-tw/admin/mapeos-clave-cuenta")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(mapeosClaveCuentaQueryOptions({ page: 1, pageSize: 15 })),
      queryClient.ensureQueryData(cuentasQueryOptions),
    ]),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminMapeosClaveCuenta]}>
      <AdminMapeosClaveCuentaPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
